export const cleanDocument = (value?: string) => {
  if (!value) return '';
  return value.replace(/[^A-Z0-9]/gi, '').toUpperCase();
};

export const formatCPF = (value?: string) => {
  if (!value) return '';
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export const cpfMask = formatCPF;

const parseCnpjInput = (value: string) => {
  const upper = value.toUpperCase();
  let base = '';
  let dv = '';

  for (const char of upper) {
    if (!/[A-Z0-9]/.test(char)) continue;

    if (base.length < 12) {
      base += char;
    } else if (/[0-9]/.test(char) && dv.length < 2) {
      dv += char;
    }
  }

  return base + dv;
};

const applyCnpjMask = (raw: string) => {
  if (raw.length <= 2) return raw;
  if (raw.length <= 5) return `${raw.slice(0, 2)}.${raw.slice(2)}`;
  if (raw.length <= 8) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5)}`;
  if (raw.length <= 12) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8)}`;

  return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12, 14)}`;
};

export const cnpjMask = (value?: string) => {
  if (!value) return '';
  return applyCnpjMask(parseCnpjInput(value));
};

export const formatDocument = (value?: string) => {
  if (!value) return '';

  const cleaned = cleanDocument(value);
  const isCnpj = /[A-Z]/.test(cleaned) || cleaned.length > 11;

  return isCnpj ? cnpjMask(value) : formatCPF(value);
};

// mascara formato (48) 99999-9999
export const phoneMask = (value?: string) => {
  if (!value) return '';
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
};

export const stripPhoneMask = phone => phone.replace(/[^0-9]/g, '');
